import { AxiosPromise, AxiosResponse } from 'axios';
import { Vue } from "vue-property-decorator";
import * as toastr from "toastr";
import moment from 'moment';
import { AppContainer, TYPES } from "@/app/index";
import { AppStateService } from '../services/core/AppStateService';
import { EntityServiceBase, EntityBase } from '@/bases';

export class FormHelper {
  public static Save<T extends EntityBase>(entityService: EntityServiceBase<T>, record: T, vueComponent: Vue, onSuccess?: (response: AxiosResponse<T>) => void, onError?: (error: any) => void): void {
    const appStateService: AppStateService = AppContainer.get<AppStateService>(TYPES.Services.AppStateService);
    if (appStateService) { appStateService.StartLoad(); }

    if (vueComponent.$v) {
      vueComponent.$v.$reset();
      vueComponent.$v.$touch();
    }

    let promise: AxiosPromise<T> = record.IsNew ? entityService.Create(record) : entityService.Update(record);
    promise
      .then((response) => {
        toastr.success("The record was saved successfully.");
        vueComponent.$emit("saved");

        if (onSuccess) { onSuccess(response); }
      })
      .catch((error) => {
        toastr.error("The record could not be saved: " + error.response.data);

        if (onError) { onError(error); }
      })
      .finally(() => {
        appStateService.EndLoad();
      });
  }

  public static Cancel(vueComponent: Vue): void {
    vueComponent.$emit("cancel");
  }

  public static ToPercentage(value: number): number {
    return value === null ? null : parseFloat((value * 100).toFixed(2));
  }

  public static FormatDate(value: any): string {
    return value === null ? null : moment.utc(value).local().format("DD/MM/YYYY");
  }

  public static FormatDateTime(value: any): string {
    return value === null ? null : moment.utc(value).local().format("DD/MM/YYYY HH:mm:ss");
  }
}
